import moda_1 from "./../../../assets/images/proyectos/moda/moda_1.jpg";
import moda_2 from "./../../../assets/images/proyectos/moda/moda_2.jpg";
import banner_pyc from "./../../../assets/images/proyectos/pyc/pyc_16.jpg";
import banner_moda from "./../../../assets/images/proyectos/moda/moda_51.jpg";
import banner_publi from "./../../../assets/images/proyectos/publicaciones/publi_10.jpg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [{
    moda: {
        title: "Moda",
        descripcion: [
            "Campaña de Publicidad para moda de un Mall en Santiago. La modelo había llegado ese día del calor de Sao Paulo al frio de invierno lluvioso de Santiago, y terminamos como a la 1 AM, muy mojados bajo la lluvia, y ella realmente muerta de frio.",
            "Catálogo de moda para un Mall. Todo casi bien, salvo que el modelo hombre, estaba con fiebre todo el día, y no quiso aplazar la sesión. Sobrevivió gracias a mucho té y analgésicos.",
            "Esta session fué una improvisación para una licitación. Tres modelos profesionales y el hijo del Director de Arte. Buscar y experimentar que se podía hacer. La foto del sillón surgió mientras ellos descansaban.",,
            "Moda para la Revista Elle Chile, en el Club Hípico de Santiago. Feo y frio día.",
            "Catálogo de Lencería. Es muy mala idea hacer un trabajo con una cámara nueva sin haberla probado. Mi primer respaldo digital para una cámara Hasselblad, que todavía no volvía de Suecia donde hubo que adaptarla para el respaldo. Entonces se me ocurrió usar una cámara prestada que no estaba bien calibrada, y no me daba foco. Usando la vieja técnica de medir el foco con una cinta métrica, logramos el foco perfecto.",
            "Campaña de lanzamiento para Lipton Iced Tea. Un largo día entre Santiago, Algarrobo y una cancha de Golf. Muy agradecidos del Cuerpo de Bomberos de Algarrobo que nos proporcionó las gotas de agua en la playa.",
            "La preciosa orfebre Luciana Dubini y su colección de joyas, maquillada por Teresita Rios y el gran peinado de Eric Gomez.",
            "Campaña de Jeans para Paris. Uno de mis últimos trabajos con película. Como extraño la diapositiva.",
            "“Prueba de Vestuario”, fue el concepto que usamos para esta sesión de fotos de moda para la revista Paula. Filmamos también un corto de moda que se puede ver en esta página.",
            "Muy mala idea también que al momento de empezar las fotos, se me caiga la cámara y se rompa. Partir a arrendar una cámara con la modelo ya vestida, y re-comenzar con una cámara desconocida, pone mucha presión. Pero: fue un día.",
            "Ropa usada. Mi segunda historia de moda para la revista Paula, y mi primera portada a pesar de mis 30 años de fotografía. Fotos look vintage para acompañar el tema."
        ],
        frase: "Ropa usada. Mi segunda historia de moda para la revista Paula, y mi primera portada a pesar de mis 30 años de fotografía. Fotos look vintage para acompañar el tema.",
        marcas: [
            moda_1,
            moda_2,
        ],
        url_back: "/proyecto/moda",
        banner: banner_moda
    },
    "productos-y-comida": {
        title: "Productos y Comida",
        descripcion: [
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
            "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        ],
        frase: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        marcas: [
            moda_1,
            moda_2,
        ],
        url_back: "/proyecto/productos-y-comida",
        banner: banner_pyc
    },
    publicaciones: {
        title: "Publicaciones",
        descripcion: [
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
            "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        ],
        frase: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        marcas: [
            moda_1,
            moda_2,
        ],
        url_back: "/proyecto/moda",
        banner: banner_publi
    },
    retratos: {
        title: "Retratos",
        descripcion: [
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
            "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        ],
        frase: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        marcas: [
            moda_1,
            moda_2,
        ],
        url_back: "/proyecto/moda",
        banner: banner_publi
    }
}]